import React from 'react';
import GuestUserDashboard from '../../containers/GuestUserDashboard';
import { Redirect } from 'react-router-dom';
import NotFound from '../../containers/NotFound';
import { getItemFromPersistentStore } from '../../utils/Persist';
import getCookieValue from '../../utils/getCookieValue';
import { setLastPath, getLastPath, setCountrySpecificPath, setCountryIsoCode } from './Constants';
import ROUTE_CONSTANTS from '../../constants/RouteConstants';
import { ROLE_IN_HOTEL } from '../../constants';
import Analytics from '../../../../common/utils/analyticsUtil';
import getQueryParamFromLink from '../../../../common/utils/getQueryParamFromLink';
import withRouterHOC from '../../../../common/components/WithRouteHOC';
import get from 'lodash/get';
import validateCountryIsoCode from '../../utils/validateCountryIsoCode';
import getRoutePath from '../../utils/getRoutePath';

class GuestProtectedRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.logUTMParamsInGA(props);
  }

  logUTMParamsInGA = (props) => {
    const { history } = props;
    const queryParmSearchString = get(history, 'location.search', '');
    const externalParams = getQueryParamFromLink(queryParmSearchString);
    const isUTMSourcePresent = externalParams.hasOwnProperty('utm_source');
    const isUTMMediumPresent = externalParams.hasOwnProperty('utm_medium');
    const isUTMCampaignPresent = externalParams.hasOwnProperty('utm_campaign');
    if (isUTMSourcePresent) {
      Analytics.registerProperties({ utm_source: String(externalParams.utm_source) });
    }
    if (isUTMMediumPresent) {
      Analytics.registerProperties({ utm_medium: String(externalParams.utm_medium) });
    }
    if (isUTMCampaignPresent) {
      Analytics.registerProperties({ utm_campaign: String(externalParams.utm_campaign) });
    }
  }

  render() {
    // Checked on render to check if user is logged in(added for api giving 400)
    const isLoggedIn = getItemFromPersistentStore('isLoggedIn', false) || getCookieValue('isLoggedIn') === 'true';
    this.isAutenticated = isLoggedIn === true;
    const props = this.props;
    const { isAuthorized = true, path, location, userDetails, isCountrySpecificPath } = props;
    const countryIsoCode = get(props, 'computedMatch.params.country_iso_code', '');
    if (!isAuthorized || userDetails.devise_role === ROLE_IN_HOTEL['PM'].role ||
      (isCountrySpecificPath && !validateCountryIsoCode(countryIsoCode))) {
      return <NotFound />;
    }

    //save values for country specific urls, which help in navigate country specific path only
    setCountrySpecificPath(isCountrySpecificPath);
    setCountryIsoCode(countryIsoCode);

    const lastPath = getLastPath();
    // TODO Commenting for now
    if (!this.isAutenticated) {
      const setPath = location.search ? location.pathname + location.search : location.pathname;
      setLastPath(setPath);
      return <Redirect to={{
        pathname: getRoutePath({ path: ROUTE_CONSTANTS.OTPSIGNUP_VIEW_V2 })
      }} />;
    }

    if (lastPath) {
      const pathToRedirect = lastPath;
      setLastPath(undefined);
      return <Redirect to={pathToRedirect} />;
    }

    return <GuestUserDashboard {...props} path={path} />;
  }
}

export default withRouterHOC(GuestProtectedRoutes);
